import { parseUserDataCookie } from "utils/common/userCookie";

const useUserType = () => {
  const user_role_name = parseUserDataCookie()?.user_role_name;
  return {
    isAdmin: user_role_name === "Admin",
    isSuperAdmin: user_role_name === "Super admin",
    isComAgent: user_role_name === "Agent commercial",
  };
};
export default useUserType;
